import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const TimeeManuaPage = lazy(() => import('../pages/timee-manual/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <TimeeManuaPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;